export default __webpack_public_path__ + "static/media/foodanddrink.b90d713c.jpg";